import { useMutation } from '@tanstack/react-query';
import { reviewInvestorDocument } from '@dealstack/frontend/shared/dataExchange/services/shareholder/investment.service';

export const useReviewDocument = () => {
	return useMutation({
		mutationKey: ['shareholder-contract-review-document-workflow'],
		mutationFn: ({
			documentWorkflowInstanceId,
			fileId,
		}: {
			documentWorkflowInstanceId: string;
			fileId: string;
		}) =>
			reviewInvestorDocument({
				documentWorkflowInstanceId,
				fileId,
			}),
	});
};
